/* global LC */
/* eslint-disable react/jsx-pascal-case */

import React from 'react';
import PropTypes from 'prop-types';
import { t } from '../../../../../../services/i18nService';

import styles from './drawingTool.scss';
import pluginStyles from './../pluginModal.scss';
import DrawingService from '../../../../../../services/DrawingService';

window.LC = require('literallycanvas');

class DrawingTool extends React.Component {
    static propTypes = {
        saveCallback: PropTypes.func.isRequired,
        dataUrlFromSelection: PropTypes.string,
        closeCallback: PropTypes.func.isRequired,
        minimizeModal: PropTypes.func.isRequired,
    };

    constructor(props) {
        super(props);
        this.state = { error: null };
    }

    componentWillUnmount() {
        if (this.lc) {
            // this.lc.teardown();
        }
    }

    componentDidCatch(error) {
        this.setState({
            error,
        });
    }

    onInit = (lc) => {
        const { dataUrlFromSelection } = this.props;
        this.lc = lc;
        if (dataUrlFromSelection) {
            // if edit an image, set it as background image
            const backgroundImage = new Image();
            backgroundImage.src = dataUrlFromSelection;
            lc.saveShape(window.LC.createShape('Image', { x: 0, y: 0, image: backgroundImage }));
        }

        this.repositionDrawingLeftMenuPart();
    };

    repositionDrawingLeftMenuPart = () => {
        const colorPickerElms = this.lc.containerEl.parentElement.getElementsByClassName('lc-color-pickers');
        const drawingMenuPartEl = colorPickerElms[0].parentElement;
        drawingMenuPartEl.style.position = 'static';
        drawingMenuPartEl.style.paddingTop = '190px';
    };

    closeModal = () => {
        this.props.closeCallback();
    };

    insertDrawing = () => {
        // Ensure 'in-progress' shapes are properly saved
        // and rendered to canvas before calling this.lc.getImage()
        // eslint-disable-next-line no-underscore-dangle
        this.lc._teardown();
        const drawing = this.lc.getImage();
        this.props.saveCallback(drawing);
    };

    saveAsDraft = () => {
        // Ensure 'in-progress' shapes are properly saved
        // and rendered to canvas before calling this.lc.getImage()
        // eslint-disable-next-line no-underscore-dangle
        this.lc._teardown();
        const drawing = this.lc.getImage();
        this.props.minimizeModal(drawing);
    };

    render() {
        let modalCloseButtonClasses = 'modalButton modalButtonClose';
        if (DrawingService.isCollapsibleDrawingModalEnabled()) {
            modalCloseButtonClasses = `${modalCloseButtonClasses} modalButtonTextUnderline`;
        }

        return (
            <div className={`${styles.drawingTool} drawing_tool_component`}>
                <div className={pluginStyles.toolbar}>
                    <div className={pluginStyles.drawingActions}>
                        <button
                            className={modalCloseButtonClasses}
                            onClick={this.closeModal}
                        >
                            {t('essay.drawing.close')}
                        </button>
                        {
                            !DrawingService.isCollapsibleDrawingModalEnabled() && (
                                <button
                                    className="modalButton modalButtonUpdate"
                                    onClick={this.insertDrawing}
                                >
                                    {t('essay.drawing.update')}
                                </button>
                            )
                        }
                    </div>
                </div>
                <div className={styles.canvasWrapper}>
                    { !this.state.error ?
                        <LC.LiterallyCanvasReactComponent
                            defaultStrokeWidth={1}
                            imageURLPrefix="lc-assets/img"
                            onInit={this.onInit}
                        />
                        :
                        <div style={{ marginTop: '5em' }}>
                            <h4>{t('status.warningText')}</h4>
                        </div>
                    }
                </div>

                { DrawingService.isCollapsibleDrawingModalEnabled() && (
                    <div className={pluginStyles.extraButtonsWrapper}>
                        <button
                            className="modalButton insertDrawing"
                            onClick={this.insertDrawing}
                        >
                            {t('essay.drawing.insertDrawing')}
                        </button>

                        <button
                            className="modalButton saveAsDraft"
                            onClick={this.saveAsDraft}
                            /* So that the focus shifts to the minimize button when opening the modal */
                            /* eslint-disable-next-line jsx-a11y/no-autofocus */
                            autoFocus
                        >
                            {t('essay.drawing.saveAsDraft')}
                        </button>
                    </div>
                )}
            </div>
        );
    }
}

export default DrawingTool;
